import { ChangeDetectionStrategy, Component } from '@angular/core';
import { selectUserConnectionStatus } from '@epicuro-next/state/connect-state';
import {
  selectUser,
  selectUserAvatarLoading,
  uploadAvatarImage,
} from '@epicuro-next/state/user-state';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

@Component({
  selector: 'epc-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserDetailsComponent {
  public user$ = this.store.select(selectUser);
  public avatarLoading$ = this.store
    .select(selectUserAvatarLoading)
    .pipe(map(Boolean));
  public userConnectionStatus$ = this.store.pipe(
    select(selectUserConnectionStatus),
  );

  constructor(private store: Store) {}

  public handleFileSelected(file: File) {
    this.store.dispatch(uploadAvatarImage({ file }));
  }
}
